import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            d="M20 8.693c-.02 1.22-.418 2.296-1.232 3.203-.503.56-1.03 1.1-1.544 1.648-.343.366-.68.74-1.035 1.093-.848.844-1.87 1.268-3.069 1.168-.953-.08-1.766-.5-2.438-1.184-.269-.275-.527-.56-.782-.847-.275-.312-.275-.648-.013-.936a.672.672 0 0 1 .982-.029c.21.215.41.436.605.664.397.461.892.77 1.482.89.811.165 1.548-.041 2.141-.617.643-.625 1.247-1.29 1.867-1.937.259-.27.521-.535.772-.814.473-.523.74-1.147.819-1.843.084-.742.018-1.469-.373-2.123-.667-1.115-1.637-1.706-2.96-1.605-.73.056-1.325.413-1.836.92-.254.251-.501.512-.752.766-.263.265-.609.28-.906.043a.674.674 0 0 1-.156-.891c.08-.125.183-.236.285-.344.468-.484.926-.975 1.518-1.319 1.6-.927 3.475-.766 4.885.4.914.755 1.46 1.728 1.667 2.89.046.262.05.532.073.797v.007Z"
        />
        <path
            fill="currentColor"
            d="M4 15.368c.032-1.32.443-2.412 1.31-3.32.885-.928 1.744-1.88 2.653-2.782 1.434-1.424 3.742-1.414 5.2-.009.312.3.618.606.91.925.284.31.312.595.129.904a.647.647 0 0 1-1.027.135c-.317-.317-.618-.65-.945-.957-.742-.693-1.593-.853-2.543-.487a2.6 2.6 0 0 0-.988.685 175.35 175.35 0 0 1-2.328 2.45c-.74.768-1.032 1.69-.943 2.739.093 1.091.6 1.952 1.529 2.533.91.569 2.156.584 3.118-.068a5.27 5.27 0 0 0 1.022-.939c.104-.12.216-.24.34-.338.273-.22.65-.186.9.064.244.242.291.637.06.886-.451.484-.87 1-1.411 1.393-1.9 1.382-4.475.95-5.894-.823-.72-.897-1.051-1.928-1.092-2.99Z"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
